import React from 'react';
import { AdminLayout } from '../../components/layouts/AdminLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Eye, CheckCircle, XCircle } from 'lucide-react';
import { toPersianDigits } from '../../utils/persian';
const claims = [{
  id: 1,
  user: 'علی احمدی',
  type: 'شخص ثالث',
  date: '1403/02/15',
  amount: '۵۰,۰۰۰,۰۰۰',
  status: 'pending'
}, {
  id: 2,
  user: 'سارا محمدی',
  type: 'بدنه',
  date: '1403/02/14',
  amount: '۱۲۰,۰۰۰,۰۰۰',
  status: 'reviewing'
}, {
  id: 3,
  user: 'رضا کریمی',
  type: 'آتش‌سوزی',
  date: '1403/02/10',
  amount: '۱۵,۰۰۰,۰۰۰',
  status: 'approved'
}];
export function ClaimsQueuePage() {
  return <AdminLayout data-id="element-193">
      <div className="space-y-6" data-id="element-194">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-195">صف بررسی خسارت‌ها</h1>

        <Card data-id="element-196">
          <CardContent data-id="element-197">
            <Table data-id="element-198">
              <TableHeader data-id="element-199">
                <TableRow data-id="element-200">
                  <TableHead data-id="element-201">کاربر</TableHead>
                  <TableHead data-id="element-202">نوع بیمه</TableHead>
                  <TableHead data-id="element-203">تاریخ حادثه</TableHead>
                  <TableHead data-id="element-204">مبلغ برآوردی (ریال)</TableHead>
                  <TableHead data-id="element-205">وضعیت</TableHead>
                  <TableHead data-id="element-206">عملیات</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-207">
                {claims.map(claim => <TableRow key={claim.id} data-id="element-208">
                    <TableCell className="font-medium" data-id="element-209">{claim.user}</TableCell>
                    <TableCell data-id="element-210">{claim.type}</TableCell>
                    <TableCell data-id="element-211">{toPersianDigits(claim.date)}</TableCell>
                    <TableCell data-id="element-212">{toPersianDigits(claim.amount)}</TableCell>
                    <TableCell data-id="element-213">
                      {claim.status === 'pending' && <Badge variant="warning" data-id="element-214">جدید</Badge>}
                      {claim.status === 'reviewing' && <Badge variant="secondary" data-id="element-215">در حال بررسی</Badge>}
                      {claim.status === 'approved' && <Badge variant="success" data-id="element-216">تایید شده</Badge>}
                    </TableCell>
                    <TableCell data-id="element-217">
                      <div className="flex items-center gap-2" data-id="element-218">
                        <Button variant="outline" size="sm" title="مشاهده جزئیات" data-id="element-219">
                          <Eye className="h-4 w-4" data-id="element-220" />
                        </Button>
                        <Button variant="ghost" size="sm" className="text-green-600 hover:text-green-700 hover:bg-green-50" title="تایید اولیه" data-id="element-221">
                          <CheckCircle className="h-4 w-4" data-id="element-222" />
                        </Button>
                        <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" title="رد درخواست" data-id="element-223">
                          <XCircle className="h-4 w-4" data-id="element-224" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>;
}